module.exports = __webpack_public_path__ + "b45783c807cb8a71ccaab8b64c3844ab.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/level_2_rustig.mp3
// module id = 193
// module chunks = 0